import { type Installation, installationSchema } from '@si/types';
import { get } from '@si/utils';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { z } from 'zod';

import { queryKeys } from './queryKeys';

const responseSchema = z.object({
  installations: z.array(installationSchema),
});

interface Params {
  projectId: string;
  enabled?: boolean;
  noRetry?: boolean;
}

export function useInstallations({ projectId, enabled = true, noRetry = false }: Params) {
  const url = `/projects/${projectId}/installations`;

  const { data, error, isLoading, refetch, isFetching } = useQuery<{
    installations: Installation[];
  }>({
    queryKey: queryKeys.getInstallations(projectId),
    queryFn: () => get({ url, schema: responseSchema }),
    enabled: enabled && !!projectId,
    placeholderData: keepPreviousData,
    retry: !noRetry,
  });

  return {
    installations: data?.installations || [],
    error,
    isLoading,
    isFetching,
    refetch,
  };
}
